const topics = [
  { name: '动作大片', hot: true, count: '1.2k' },
  { name: '喜剧电影', hot: true, count: '980' },
  { name: '科幻巨制', hot: true, count: '856' },
  { name: '悬疑推理', hot: false, count: '720' },
  { name: '国产佳片', hot: true, count: '1.1k' },
  { name: '日韩电影', hot: false, count: '650' },
  { name: '欧美热映', hot: true, count: '930' },
  { name: '动画电影', hot: false, count: '580' },
  { name: '经典回顾', hot: false, count: '890' },
  { name: '恐怖惊悚', hot: false, count: '470' },
  { name: '纪录片', hot: false, count: '340' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-300 bg-primary-500/10 rounded-full mb-4">
            热议话题
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            热议话题标签
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            看看大家都在关注哪些电影类型和话题，找到属于你的观影圈子
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className={`group relative flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-300 ${
                topic.hot
                  ? 'bg-accent-500/15 border border-accent-500/25 hover:bg-accent-500/25 hover:border-accent-500/40'
                  : 'bg-background-200/70 border border-background-300/40 hover:bg-background-300/50 hover:border-background-400/40'
              }`}
            >
              {topic.hot && (
                <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              )}
              <span className={`text-sm font-medium ${topic.hot ? 'text-accent-200' : 'text-foreground-300'}`}>
                {topic.name}
              </span>
              <span className={`text-xs ${topic.hot ? 'text-accent-400/60' : 'text-foreground-600'}`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}